import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Municipio } from 'src/app/models/municipio';
import { Estado } from 'src/app/models/estado';
import { Instituicao } from 'src/app/models/instituicao';
import { InstituicoesService } from 'src/app/instituicoes-ensino/instituicoes-service';

@Component({
  selector: 'app-instituicao-busca',
  templateUrl: './instituicao-busca.component.html',
  styleUrls: ['./instituicao-busca.component.scss']
})
export class InstituicaoBuscaComponent implements OnInit {
  /* tslint:disable-next-line:no-input-rename */
  @Input('componenteRef') componenteAtual: string;
  @Input() instituicoes?: Instituicao[];

  searchString: string;
  stringBusca: string;
  nome: string;
  searchText = '';
  municipios: Municipio[] = [];
  estados: Estado[];
  ufSelecionado: Estado[] = [];
  estadosSelecionados = '';
  municipiosSelecionados = '';
  tipoInstituicaoSelecionados = '';
  retorno: Instituicao[] = [];
  todosEstados = false;
  todosMunicipios = false;
  todosTipos = false;

  ordenarPor = [
    { id: 'asc', nome: 'Ordem Alfabética (A - Z)' },
    { id: 'desc', nome: 'Ordem Alfabética (Z - A)' },
  ];

  tiposInstituicoes = [
    { nome: 'Todos' },
    { nome: 'Pública' },
    { nome: 'Privada' },
    { nome: 'Militar' },
    { nome: 'Serviço Nacional de Aprendizagem' }
  ];

  toggle = false;
  formularioPesquisaInstituicao: FormGroup;

  @Output() inputEvent = new EventEmitter<any>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private server: InstituicoesService) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((q) => {
      this.nome = q.nomeCurso ? q.nomeCurso : '';
    });

    this.formularioPesquisaInstituicao = new FormGroup({
      stringBusca: new FormControl(this.searchString),
      ordenacao: new FormControl('asc'),
      municipiosSelecionados: new FormControl(this.municipiosSelecionados),
      estadosSelecionados: new FormControl(this.estadosSelecionados),
      tipoInstituicaoSelecionados: new FormControl(this.tipoInstituicaoSelecionados),
    });
    this.instituicoes = this.server.getInstituicoes();
    this.estados = this.server.getEstados();
  }

  onPesquisar() {
    this.stringBusca = this.formularioPesquisaInstituicao.value.stringBusca;

    this.router.navigate(['/cursos/filtro-instituicoes'], {
      queryParamsHandling: 'merge',
      queryParams: {
        stringBusca: this.stringBusca,
        municipiosSelecionados: this.municipiosSelecionados,
        estadosSelecionados: this.estadosSelecionados,
        tipoInstituicaoSelecionados: this.tipoInstituicaoSelecionados,
      },
    });

    this.municipiosSelecionados = '';
    this.estadosSelecionados = '';
    this.tipoInstituicaoSelecionados = '';
    this.stringBusca = '';
  }

  updateAllComplete() {
    this.todosEstados = this.estados != null && this.estados.every(t => t.selecionado);
  }

  someComplete(): boolean {
    if (this.estados == null) {
      return false;
    }
    return this.estados.filter(t => t.selecionado).length > 0 && !this.todosEstados;
  }

  setAll() {
    if (this.todosEstados) {
      this.todosEstados = false;
      this.estadosSelecionados = '';
    } else {
      this.todosEstados = true;
      this.estadosSelecionados = 'TD';
      this.municipios = [];
    }
  }

  getSelectedEstado(e: any) {
    const posicao = this.estadosSelecionados.indexOf(e.uf);
    if (this.estadosSelecionados !== 'undefined' && posicao >= 0) {
      this.estadosSelecionados = this.estadosSelecionados.replace(e.uf + '--', '');
    } else {
      this.estadosSelecionados += e.uf + '--';
    }

    if (this.estadosSelecionados.length > 4) {
      this.municipios = [];
    } else {
      const estado = this.estadosSelecionados.slice(0, 2);

      this.estados.forEach(uf => {
        if (uf.uf === estado) {
          uf.municipios.forEach(municipio => {
            this.municipios.push(municipio);
          });
        }
      });
    }
  }

  setAllMunicipio() {
    if (this.todosMunicipios) {
      this.todosMunicipios = false;
      this.municipiosSelecionados = '';
    } else {
      this.todosMunicipios = true;
      this.municipiosSelecionados = 'TD';
    }
  }

  getSelectedMunicipio(e: any) {
    if (this.municipiosSelecionados !== 'undefined' && this.municipiosSelecionados.indexOf(e.nome) >= 0) {
      this.municipiosSelecionados = this.municipiosSelecionados.replace(e.nome + '--', '');
    }
    this.municipiosSelecionados += e.nome + '--';
  }

  getSelectedTipoInstituicao(e: any) {
    if (e.nome === 'Todos') {
      this.tipoInstituicaoSelecionados = 'TD';
      this.todosTipos = true;
    } else {
      if (this.todosTipos) {
        this.todosTipos = false;
        this.tipoInstituicaoSelecionados = '';
      }
      this.tipoInstituicaoSelecionados += e.nome + '--';
    }
  }

}
